// extracted by mini-css-extract-plugin
module.exports = {"SettingsBar":"SettingsBar_SettingsBar__345SO","User":"SettingsBar_User__1zgvY","User_icon":"SettingsBar_User_icon__yTWhF","User_name":"SettingsBar_User_name___TDCi"};